module.exports = __webpack_public_path__ + "6da021e4aa6aa73866a1e0964a34234f.jpg";